
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Send } from "lucide-react";
import { KeyboardEvent } from "react";

interface MessageInputProps {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  isDisabled?: boolean;
}

export const MessageInput = ({ value, onChange, onSend, isDisabled = false }: MessageInputProps) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (value.trim() && !isDisabled) {
      onSend();
    }
  };
  
  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    // Send message on Enter (without Shift)
    if (e.key === 'Enter' && !e.shiftKey && !isDisabled) {
      e.preventDefault();
      if (value.trim()) {
        onSend();
      }
    }
  };

  return (
    <form 
      onSubmit={handleSubmit}
      className="sticky bottom-0 p-4 border-t bg-background"
    >
      <div className="flex gap-2">
        <Input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Message..."
          className="flex-1"
          autoFocus
          disabled={isDisabled}
        />
        <Button 
          type="submit"
          variant="ghost"
          size="icon"
          className="rounded-full"
          disabled={!value.trim() || isDisabled}
        >
          <Send className="h-5 w-5 text-primary" />
        </Button>
      </div>
    </form>
  );
};
